// extracted by mini-css-extract-plugin
module.exports = {"nav":"TeamNav-module--nav--KcAtH","button":"TeamNav-module--button---mg7A","active":"TeamNav-module--active--3H_gv"};